<template>
  <div class="page-ct">
    <div class="header-ct">
      <h1>{{ $t('CompanyDashboard_AllProjects') }}</h1>
      <router-link
        v-if="$can('createProject') && !isLoadingProjectMetrics"
        to="/account/project/create"
      >
        <el-button type="primary">
          <div class="btn-content-wrapper">
            <icon glyph="plus" size="20" />
            <div class="btn-text">
              {{ $t('CompanyDashboard_CreateNewProject') }}
            </div>
          </div>
        </el-button>
      </router-link>
    </div>

    <div class="separator" />

    <div
      class="welcome-ct"
      v-if="!isLoadingProjectMetrics && projectsData.length === 0"
    >
      <h3>{{ $t('CompanyDashboard_Welcome') }}</h3>
      <p class="welcome-msg" v-html="$t('CompanyDashboard_WelcomeMessage')" />
    </div>

    <div class="key-metrics" v-if="showMetrics && keyMetrics.length > 0">
      <h3>{{ $t('CompanyDashboard_KeyMetrics') }}</h3>
      <div class="metrics-ct">
        <div v-for="keyMetric in keyMetrics" class="metric">
          <key-metric
            v-loading="isLoadingKeyMetrics"
            :metric="keyMetric.value"
            :title="
              metricLabels.hasOwnProperty(keyMetric.name)
                ? $t(metricLabels[keyMetric.name])
                : keyMetric.name
            "
            :type="keyMetric.type"
          />
        </div>
        <div
          v-if="projectsData.length === 0"
          v-for="index in 2"
          :key="index"
          class="metric"
        >
          <key-metric-placeholder />
        </div>
      </div>
    </div>

    <div class="projects">
      <h3>{{ $t('CompanyDashboard_Projects') }}</h3>
      <rest-cards
        v-loading="isLoadingProjectMetrics"
        :payload="projectTilesEndpoint"
        @loaded-project-metrics="isLoadingProjectMetrics = false"
        @projects-data="projectsData = $event"
      />
    </div>
  </div>
</template>
<script>
import KeyMetric from '@/common/components/KeyMetric'
import RestCards from '@/common/components/rest/RestCards'
import KeyMetricPlaceholder from '@/common/components/KeyMetricPlaceholder'
import RestApi from '@/core/services/RestApi'
import { metricLabels } from '@/common/components/dashboard/Labels'
import { $isAdmin } from '@/core/utils/VueAcl'

export default {
  name: 'CompanyDashboard',

  components: {
    RestCards,
    KeyMetric,
    KeyMetricPlaceholder
  },

  data() {
    return {
      keyMetrics: [],
      metricLabels,
      isLoadingKeyMetrics: true,
      isLoadingProjectMetrics: true,
      projectsData: {},
      projectsLimit: 50,
      showMetrics: !$isAdmin()
    }
  },

  computed: {
    projects() {
      return this.$store.state.app.projects
    },

    projectTilesEndpoint() {
      return {
        method: 'get',
        url: 'projects',
        params: {
          sort: 'title',
          fields: 'id,name,icon,maxautomation,project_status',
          expand: 'project_overview_metrics',
          'per-page': 10
        }
      }
    }
  },

  mounted() {
    if (
      this.showMetrics &&
      this.$store.state.app.company &&
      this.$store.state.app.company.projects_count < this.projectsLimit
    ) {
      RestApi.get('projects/key-metrics').then(response => {
        response.data.forEach((item, index) => {
          this.$set(this.keyMetrics, index, item)
          this.isLoadingKeyMetrics = false
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.page-ct {
  padding: 20px 0;
  width: 100%;
  background-color: #f2f5f9;
  overflow: auto;

  > div {
    margin-left: auto;
    margin-right: auto;
    width: 1092px;
  }

  .header-ct {
    display: flex;
    justify-content: space-between;
    padding-bottom: 28px;
    padding-top: 6px;
  }

  .separator {
    height: 1px;
    width: 100%;
    margin-bottom: 28px;
    background-color: #e6e6e6;
  }

  h3 {
    margin-bottom: 10px;
  }

  .welcome-ct {
    margin-bottom: 28px;

    .welcome-msg {
      width: 536px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #808080;
    }
  }

  .key-metrics {
    margin-bottom: 28px;

    .metrics-ct {
      display: flex;
      flex-direction: row;

      .metric > div {
        width: 260px;
        margin-right: 13px;
      }
    }
  }

  .projects {
    margin-bottom: 28px;
  }

  button {
    padding: 0 14px;
    height: 36px;

    .btn-content-wrapper {
      display: flex;

      .btn-text {
        font-size: 14px;
        margin: auto 0 auto 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/pages/CompanyDashboard.vue